<template>
  <div>
    <el-tabs type="border-card" class="fullHeight">
      <el-tab-pane class="paddingBody content" :label="$t('Listado de solicitudes')">
        <el-row>
          <el-col :span="24">
            <el-select @change="getSolicitudes" style="margin-right: 10px" size="medium" v-model="faena_selected"
              placeholder="Seleccione una faena">
              <el-option v-for="(item, index) in $store.getters.faenas" :key="index" :label="item.nombre"
                :value="item._id">
              </el-option>
            </el-select>
            <el-input :placeholder="$t('Búsqueda por código y nombre del contrato')" v-model="search" class="search"
              size="medium"></el-input>
            <el-button icon="el-icon-search" style="margin-left: 10px" size="medium" type="primary"
              @click="getSolicitudes">Búscar</el-button>
          </el-col>
        </el-row>
        <br /><br />
        <el-row>
          <el-col :sm="24">
            <el-table row-class-name="rowClassTablaPloma" cell-class-name="cellClassTablaPloma"
              header-cell-class-name="header-cell-class-table-gray" v-loading="loading" :data="solicitudes"
              style="width: 100%">
              <el-table-column width="300" label="Faena">
                <template slot-scope="scope">
                  {{ getFaena(scope.row.faena_id) }}
                </template>
              </el-table-column>
              <el-table-column width="300" label="Fecha ingreso">
                <template slot-scope="scope">
                  {{ dateFromObjectId(scope.row._id) | moment("LLL") }}
                </template>
              </el-table-column>
              <el-table-column width="220" prop="tipo_contrato" label="Tipo contrato">
              </el-table-column>
              <el-table-column prop="nombre_contrato" label="Contrato">
              </el-table-column>
              <el-table-column width="300" prop="codigo" label="Código">
              </el-table-column>
              <el-table-column width="200" label="Estado">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.seguimiento[scope.row.seguimiento.length - 1][
                    'estado'
                  ] === 'Solicitud ingresada'
                    ? 'info'
                    : scope.row.seguimiento[
                      scope.row.seguimiento.length - 1
                    ]['estado'] === 'Solicitud en trámite'
                      ? 'warning'
                      : scope.row.seguimiento[
                        scope.row.seguimiento.length - 1
                      ]['estado'] === 'Solicitud finalizada'
                        ? 'success'
                        : ''
                    " size="medium">{{
                      scope.row.seguimiento[scope.row.seguimiento.length - 1][
                      "estado"
                      ]
                    }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column width="200" label="Opciones" v-if="!$store.getters.user.readonly">
                <template slot-scope="scope">
                  <i @click="openVer(scope.row)" style="font-size: 25px; cursor: pointer" class="el-icon-view"></i>
                  <i @click="openMensaje(scope.row)" style="font-size: 25px; cursor: pointer; margin-left: 10px"
                    class="el-icon-message"></i>
                </template>
              </el-table-column>
            </el-table>
            <br />
            <br />
            <center>
              <el-pagination :current-page="page" @prev-click="backPage" @next-click="nextPage"
                @current-change="currentPage" :page-size="6" layout="prev, pager, next"
                :total="totalPage"></el-pagination>
            </center>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>

    <el-dialog title="Solicitud" :visible.sync="dialogVer" width="50%" :before-close="handleClose">
      <br />
      <el-row v-if="solicitud.tipo_contrato === 'Contratista'">
        <el-col :sm="24">
          <el-form label-position="left" status-icon label-width="200px">
            <b><span style="font-size: 14px">Información del solicitante</span></b>
            <br /><br /><br />
            <el-form-item label="Usuario solicitante">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.creador"></el-input>
              <el-button size="medium" @click="copiar(solicitud.creador)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Email usuario solicitante">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.email_creador"></el-input>
              <el-button size="medium" @click="copiar(solicitud.email_creador)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Celular usuario solicitante">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.creador_movil"></el-input>
              <el-button size="medium" @click="copiar(solicitud.creador_movil)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <br>
            <b><span style="font-size: 14px">Información general</span></b>
            <br /><br /><br />
            <el-form-item label="Tipo de contrato">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.tipo_contrato"></el-input>
              <el-button size="medium" @click="copiar(solicitud.tipo_contrato)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Nombre de empresa">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.nombre_empresa"></el-input>
              <el-button size="medium" @click="copiar(solicitud.nombre_empresa)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Rut de empresa">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.rut_empresa"></el-input>
              <el-button size="medium" @click="copiar(solicitud.rut_empresa)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="N° de contrato">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.numero_contrato"></el-input>
              <el-button size="medium" @click="copiar(solicitud.numero_contrato)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Nombre del contrato">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.nombre_contrato"></el-input>
              <el-button size="medium" @click="copiar(solicitud.nombre_contrato)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Alcance del contrato">
              <el-input readonly style="width: 85%" type="textarea" :rows="3" size="medium"
                v-model="solicitud.alcance_contrato"></el-input>
              <el-button size="medium" @click="copiar(solicitud.alcance_contrato)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Fecha de inicio">
              <el-date-picker style="width: 350px" size="medium" v-model="solicitud.fecha_inicio" type="date"
                placeholder="Seleccione un día">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="Fecha de fin">
              <el-date-picker style="width: 350px" size="medium" v-model="solicitud.fecha_fin" type="date"
                placeholder="Seleccione un día">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="Nombre contract owner (SPA)">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.nombre_owner"></el-input>
              <el-button size="medium" @click="copiar(solicitud.nombre_owner)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Correo contract owner (SPA)">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.email_owner"></el-input>
              <el-button size="medium" @click="copiar(solicitud.email_owner)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Gerencia General">
              <el-select filterable disabled size="medium" style="width: 100%" v-model="solicitud.gerencia_general"
                placeholder="Seleccione una opción">
                <el-option v-for="(item, index) in gerencias_generales" :key="index" :label="item.nombre"
                  :value="item._id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Gerencia">
              <el-select filterable disabled size="medium" style="width: 100%" v-model="solicitud.gerencia"
                placeholder="Seleccione una opción">
                <el-option v-for="(item, index) in gerencias" :key="index" :label="item.nombre" :value="item._id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Superintendencia">
              <el-select filterable disabled size="medium" style="width: 100%" v-model="solicitud.superintendencia"
                placeholder="Seleccione una opción">
                <el-option v-for="(item, index) in superintendencias" :key="index" :label="item.nombre"
                  :value="item._id">
                </el-option>
              </el-select>
            </el-form-item>
            <br />
            <hr />
            <br />
            <b><span style="font-size: 14px">Coordinador - Esta será la persona encargada de crear el
                inventario en el sistema.</span></b>
            <br /><br /><br />
            <el-form-item label="Nombre">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.nombre_coordinador"></el-input>
              <el-button size="medium" @click="copiar(solicitud.nombre_coordinador)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Apellido paterno">
              <el-input readonly style="width: 85%" size="medium"
                v-model="solicitud.apellido_paterno_coordinador"></el-input>
              <el-button size="medium" @click="copiar(solicitud.apellido_paterno_coordinador)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Apellido materno">
              <el-input readonly style="width: 85%" size="medium"
                v-model="solicitud.apellido_materno_coordinador"></el-input>
              <el-button size="medium" @click="copiar(solicitud.apellido_materno_coordinador)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Nombre de usuario">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.coordinador_rut"></el-input>
              <el-button size="medium" @click="copiar(solicitud.coordinador_rut)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Correo electrónico">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.coordinador_correo"></el-input>
              <el-button size="medium" @click="copiar(solicitud.coordinador_correo)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Cargo">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.coordinador_cargo"></el-input>
              <el-button size="medium" @click="copiar(solicitud.coordinador_cargo)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Celular">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.coordinador_celular"></el-input>
              <el-button size="medium" @click="copiar(solicitud.coordinador_celular)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <br />
            <hr />
            <br />
            <b><span style="font-size: 14px">HSE Contratista 1 - Su tarea es aprobar el inventario.
              </span></b>
            <br /><br /><br />
            <el-form-item label="Nombre">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.nombre_hse1"></el-input>
              <el-button size="medium" @click="copiar(solicitud.nombre_hse1)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Apellido paterno">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.apellido_paterno_hse1"></el-input>
              <el-button size="medium" @click="copiar(solicitud.apellido_paterno_hse1)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Apellido materno">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.apellido_materno_hse1"></el-input>
              <el-button size="medium" @click="copiar(solicitud.apellido_materno_hse1)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Nombre de usuario">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.hse1_rut"></el-input>
              <el-button size="medium" @click="copiar(solicitud.hse1_rut)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Correo electrónico">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.hse1_correo"></el-input>
              <el-button size="medium" @click="copiar(solicitud.hse1_correo)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Cargo">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.hse1_cargo"></el-input>
              <el-button size="medium" @click="copiar(solicitud.hse1_cargo)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Celular">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.hse1_celular"></el-input>
              <el-button size="medium" @click="copiar(solicitud.hse1_celular)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <br />
            <hr />
            <br />
            <b><span style="font-size: 14px">HSE Contratista 2 - Su tarea es aprobar el inventario.
              </span></b>
            <br /><br /><br />
            <el-form-item label="Nombre">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.nombre_hse2"></el-input>
              <el-button size="medium" @click="copiar(solicitud.nombre_hse2)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Apellido paterno">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.apellido_paterno_hse2"></el-input>
              <el-button size="medium" @click="copiar(solicitud.apellido_paterno_hse2)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Apellido materno">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.apellido_materno_hse2"></el-input>
              <el-button size="medium" @click="copiar(solicitud.apellido_materno_hse2)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Nombre de usuario">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.hse2_rut"></el-input>
              <el-button size="medium" @click="copiar(solicitud.hse2_rut)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Correo electrónico">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.hse2_correo"></el-input>
              <el-button size="medium" @click="copiar(solicitud.hse2_correo)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Cargo">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.hse2_cargo"></el-input>
              <el-button size="medium" @click="copiar(solicitud.hse2_cargo)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Celular">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.hse2_celular"></el-input>
              <el-button size="medium" @click="copiar(solicitud.hse2_celular)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <br />
            <hr />
            <br />
            <b><span style="font-size: 14px">Administrador - No puede ser Coordinador y HSE (Su tarea es
                aprobar el inventario).
              </span></b>
            <br /><br /><br />
            <el-form-item label="Nombre">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.nombre_administrador2"></el-input>
              <el-button size="medium" @click="copiar(solicitud.nombre_administrador2)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Apellido paterno">
              <el-input readonly style="width: 85%" size="medium"
                v-model="solicitud.apellido_paterno_administrador2"></el-input>
              <el-button size="medium" @click="copiar(solicitud.apellido_paterno_administrador2)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Apellido materno">
              <el-input readonly style="width: 85%" size="medium"
                v-model="solicitud.apellido_materno_administrador2"></el-input>
              <el-button size="medium" @click="copiar(solicitud.apellido_materno_administrador2)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Nombre de usuario">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.administrador_rut"></el-input>
              <el-button size="medium" @click="copiar(solicitud.administrador_rut)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Correo electrónico">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.administrador_correo"></el-input>
              <el-button size="medium" @click="copiar(solicitud.administrador_correo)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Cargo">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.administrador_cargo"></el-input>
              <el-button size="medium" @click="copiar(solicitud.administrador_cargo)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Celular">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.administrador_celular"></el-input>
              <el-button size="medium" @click="copiar(solicitud.administrador_celular)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <!-- PROPIO -->
      <el-row v-if="solicitud.tipo_contrato === 'Propio'">
        <el-col :sm="24">
          <el-form label-position="left" status-icon label-width="200px">
            <b><span style="font-size: 14px">Información del solicitante</span></b>
            <br /><br /><br />
            <el-form-item label="Usuario solicitante">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.creador"></el-input>
              <el-button size="medium" @click="copiar(solicitud.creador)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Email usuario solicitante">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.email_creador"></el-input>
              <el-button size="medium" @click="copiar(solicitud.email_creador)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Celular usuario solicitante">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.creador_movil"></el-input>
              <el-button size="medium" @click="copiar(solicitud.creador_movil)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <br>
            <b><span style="font-size: 14px">Información general</span></b>
            <br /><br /><br />
            <el-form-item label="Tipo de contrato">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.tipo_contrato"></el-input>
              <el-button size="medium" @click="copiar(solicitud.tipo_contrato)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Nombre del contrato">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.nombre_contrato"></el-input>
              <el-button size="medium" @click="copiar(solicitud.nombre_contrato)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Gerencia General">
              <el-select filterable disabled size="medium" style="width: 100%" v-model="solicitud.gerencia_general"
                placeholder="Seleccione una opción">
                <el-option v-for="(item, index) in gerencias_generales" :key="index" :label="item.nombre"
                  :value="item._id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Gerencia">
              <el-select filterable disabled size="medium" style="width: 100%" v-model="solicitud.gerencia"
                placeholder="Seleccione una opción">
                <el-option v-for="(item, index) in gerencias" :key="index" :label="item.nombre" :value="item._id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Superintendencia">
              <el-select filterable disabled size="medium" style="width: 100%" v-model="solicitud.superintendencia"
                placeholder="Seleccione una opción">
                <el-option v-for="(item, index) in superintendencias" :key="index" :label="item.nombre"
                  :value="item._id">
                </el-option>
              </el-select>
            </el-form-item>
            <br />
            <hr />
            <br />
            <b><span style="font-size: 14px">Coordinador - Esta será la persona encargada de crear el
                inventario en el sistema.</span></b>
            <br /><br /><br />
            <el-form-item label="Nombre">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.nombre_coordinador"></el-input>
              <el-button size="medium" @click="copiar(solicitud.nombre_coordinador)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Apellido paterno">
              <el-input readonly style="width: 85%" size="medium"
                v-model="solicitud.apellido_paterno_coordinador"></el-input>
              <el-button size="medium" @click="copiar(solicitud.apellido_paterno_coordinador)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Apellido materno">
              <el-input readonly style="width: 85%" size="medium"
                v-model="solicitud.apellido_materno_coordinador"></el-input>
              <el-button size="medium" @click="copiar(solicitud.apellido_materno_coordinador)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Nombre de usuario">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.coordinador_rut"></el-input>
              <el-button size="medium" @click="copiar(solicitud.coordinador_rut)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Correo electrónico">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.coordinador_correo"></el-input>
              <el-button size="medium" @click="copiar(solicitud.coordinador_correo)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Cargo">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.coordinador_cargo"></el-input>
              <el-button size="medium" @click="copiar(solicitud.coordinador_cargo)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Celular">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.coordinador_celular"></el-input>
              <el-button size="medium" @click="copiar(solicitud.coordinador_celular)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <br />
            <hr />
            <br />
            <b><span style="font-size: 14px">Especialista de salud 1 - Su tarea es aprobar el inventario.
              </span></b>
            <br /><br /><br />
            <el-form-item label="Nombre">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.nombre_salud"></el-input>
              <el-button size="medium" @click="copiar(solicitud.nombre_salud)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Apellido paterno">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.apellido_paterno_salud"></el-input>
              <el-button size="medium" @click="copiar(solicitud.apellido_paterno_salud)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Apellido materno">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.apellido_materno_salud"></el-input>
              <el-button size="medium" @click="copiar(solicitud.apellido_materno_salud)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Nombre de usuario">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.salud_rut"></el-input>
              <el-button size="medium" @click="copiar(solicitud.salud_rut)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Correo electrónico">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.salud_correo"></el-input>
              <el-button size="medium" @click="copiar(solicitud.salud_correo)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Cargo">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.salud_cargo"></el-input>
              <el-button size="medium" @click="copiar(solicitud.salud_cargo)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Celular">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.salud_celular"></el-input>
              <el-button size="medium" @click="copiar(solicitud.salud_celular)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <br />
            <hr />
            <br />
            <b><span style="font-size: 14px">Especialista de salud 2 - Su tarea es aprobar el inventario.
              </span></b>
            <br /><br /><br />
            <el-form-item label="Nombre">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.nombre_salud2"></el-input>
              <el-button size="medium" @click="copiar(solicitud.nombre_salud2)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Apellido paterno">
              <el-input readonly style="width: 85%" size="medium"
                v-model="solicitud.apellido_paterno_salud2"></el-input>
              <el-button size="medium" @click="copiar(solicitud.apellido_paterno_salud2)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Apellido materno">
              <el-input readonly style="width: 85%" size="medium"
                v-model="solicitud.apellido_materno_salud2"></el-input>
              <el-button size="medium" @click="copiar(solicitud.apellido_materno_salud2)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Nombre de usuario">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.salud2_rut"></el-input>
              <el-button size="medium" @click="copiar(solicitud.salud2_rut)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Correo electrónico">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.salud2_correo"></el-input>
              <el-button size="medium" @click="copiar(solicitud.salud2_correo)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Cargo">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.salud2_cargo"></el-input>
              <el-button size="medium" @click="copiar(solicitud.salud2_cargo)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Celular">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.salud2_celular"></el-input>
              <el-button size="medium" @click="copiar(solicitud.salud2_celular)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <br />
            <hr />
            <br />
            <b><span style="font-size: 14px">Especialista de seguridad 1 - Su tarea es aprobar el
                inventario.
              </span></b>
            <br /><br /><br />
            <el-form-item label="Nombre">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.nombre_seguridad"></el-input>
              <el-button size="medium" @click="copiar(solicitud.nombre_seguridad)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Apellido paterno">
              <el-input readonly style="width: 85%" size="medium"
                v-model="solicitud.apellido_paterno_seguridad"></el-input>
              <el-button size="medium" @click="copiar(solicitud.apellido_paterno_seguridad)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Apellido materno">
              <el-input readonly style="width: 85%" size="medium"
                v-model="solicitud.apellido_materno_seguridad"></el-input>
              <el-button size="medium" @click="copiar(solicitud.apellido_materno_seguridad)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Nombre de usuario">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.seguridad_rut"></el-input>
              <el-button size="medium" @click="copiar(solicitud.seguridad_rut)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Correo electrónico">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.seguridad_correo"></el-input>
              <el-button size="medium" @click="copiar(solicitud.seguridad_correo)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Cargo">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.seguridad_cargo"></el-input>
              <el-button size="medium" @click="copiar(solicitud.seguridad_cargo)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Celular">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.seguridad_celular"></el-input>
              <el-button size="medium" @click="copiar(solicitud.seguridad_celular)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <br />
            <hr />
            <br />
            <b><span style="font-size: 14px">Especialista de seguridad 2 - Su tarea es aprobar el
                inventario.
              </span></b>
            <br /><br /><br />
            <el-form-item label="Nombre">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.nombre_seguridad2"></el-input>
              <el-button size="medium" @click="copiar(solicitud.nombre_seguridad2)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Apellido paterno">
              <el-input readonly style="width: 85%" size="medium"
                v-model="solicitud.apellido_paterno_seguridad2"></el-input>
              <el-button size="medium" @click="copiar(solicitud.apellido_paterno_seguridad2)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Apellido materno">
              <el-input readonly style="width: 85%" size="medium"
                v-model="solicitud.apellido_materno_seguridad2"></el-input>
              <el-button size="medium" @click="copiar(solicitud.apellido_materno_seguridad2)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Nombre de usuario">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.seguridad2_rut"></el-input>
              <el-button size="medium" @click="copiar(solicitud.seguridad2_rut)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Correo electrónico">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.seguridad2_correo"></el-input>
              <el-button size="medium" @click="copiar(solicitud.seguridad2_correo)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Cargo">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.seguridad2_cargo"></el-input>
              <el-button size="medium" @click="copiar(solicitud.seguridad2_cargo)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Celular">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.seguridad2_celular"></el-input>
              <el-button size="medium" @click="copiar(solicitud.seguridad2_celular)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <br />
            <hr />
            <br />
            <b><span style="font-size: 14px">Especialista de medioambiente 1 - Su tarea es aprobar el
                inventario.
              </span></b>
            <br /><br /><br />
            <el-form-item label="Nombre">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.nombre_medioambiente"></el-input>
              <el-button size="medium" @click="copiar(solicitud.nombre_medioambiente)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Apellido paterno">
              <el-input readonly style="width: 85%" size="medium"
                v-model="solicitud.apellido_paterno_medioambiente"></el-input>
              <el-button size="medium" @click="copiar(solicitud.apellido_paterno_medioambiente)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Apellido materno">
              <el-input readonly style="width: 85%" size="medium"
                v-model="solicitud.apellido_materno_medioambiente"></el-input>
              <el-button size="medium" @click="copiar(solicitud.apellido_materno_medioambiente)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Nombre de usuario">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.medioambiente_rut"></el-input>
              <el-button size="medium" @click="copiar(solicitud.medioambiente_rut)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Correo electrónico">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.medioambiente_correo"></el-input>
              <el-button size="medium" @click="copiar(solicitud.medioambiente_correo)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Cargo">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.medioambiente_cargo"></el-input>
              <el-button size="medium" @click="copiar(solicitud.medioambiente_cargo)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Celular">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.medioambiente_celular"></el-input>
              <el-button size="medium" @click="copiar(solicitud.medioambiente_celular)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <br />
            <hr />
            <br />
            <b><span style="font-size: 14px">Especialista de medioambiente 2 - Su tarea es aprobar el
                inventario.
              </span></b>
            <br /><br /><br />
            <el-form-item label="Nombre">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.nombre_medioambiente2"></el-input>
              <el-button size="medium" @click="copiar(solicitud.nombre_medioambiente2)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Apellido paterno">
              <el-input readonly style="width: 85%" size="medium"
                v-model="solicitud.apellido_paterno_medioambiente2"></el-input>
              <el-button size="medium" @click="copiar(solicitud.apellido_paterno_medioambiente2)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Apellido materno">
              <el-input readonly style="width: 85%" size="medium"
                v-model="solicitud.apellido_materno_medioambiente2"></el-input>
              <el-button size="medium" @click="copiar(solicitud.apellido_materno_medioambiente2)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Nombre de usuario">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.medioambiente2_rut"></el-input>
              <el-button size="medium" @click="copiar(solicitud.medioambiente2_rut)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Correo electrónico">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.medioambiente2_correo"></el-input>
              <el-button size="medium" @click="copiar(solicitud.medioambiente2_correo)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Cargo">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.medioambiente2_cargo"></el-input>
              <el-button size="medium" @click="copiar(solicitud.medioambiente2_cargo)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Celular">
              <el-input readonly style="width: 85%" size="medium" v-model="solicitud.medioambiente2_celular"></el-input>
              <el-button size="medium" @click="copiar(solicitud.medioambiente2_celular)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <br />
            <hr />
            <br />
            <b><span style="font-size: 14px">Especialista de Riesgo - Su tarea es aprobar el inventario.
              </span></b>
            <br /><br /><br />
            <el-form-item label="Nombre">
              <el-input readonly style="width: 85%" size="medium"
                v-model="solicitud.nombre_especialista_riesgo"></el-input>
              <el-button size="medium" @click="copiar(solicitud.nombre_especialista_riesgo)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Apellido paterno">
              <el-input readonly style="width: 85%" size="medium"
                v-model="solicitud.apellido_paterno_especialista_riesgo"></el-input>
              <el-button size="medium" @click="copiar(solicitud.apellido_paterno_especialista_riesgo)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Apellido materno">
              <el-input readonly style="width: 85%" size="medium"
                v-model="solicitud.apellido_materno_especialista_riesgo"></el-input>
              <el-button size="medium" @click="copiar(solicitud.apellido_materno_especialista_riesgo)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Nombre de usuario">
              <el-input readonly style="width: 85%" size="medium"
                v-model="solicitud.especialista_riesgo_rut"></el-input>
              <el-button size="medium" @click="copiar(solicitud.especialista_riesgo_rut)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Correo electrónico">
              <el-input readonly style="width: 85%" size="medium"
                v-model="solicitud.especialista_riesgo_correo"></el-input>
              <el-button size="medium" @click="copiar(solicitud.especialista_riesgo_correo)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Cargo">
              <el-input readonly style="width: 85%" size="medium"
                v-model="solicitud.especialista_riesgo_cargo"></el-input>
              <el-button size="medium" @click="copiar(solicitud.especialista_riesgo_cargo)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
            <el-form-item label="Celular">
              <el-input readonly style="width: 85%" size="medium"
                v-model="solicitud.especialista_riesgo_celular"></el-input>
              <el-button size="medium" @click="copiar(solicitud.especialista_riesgo_celular)" type="info"><i
                  class="el-icon-edit-outline"></i></el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClose">Cancelar</el-button>
      </span>
    </el-dialog>

    <el-dialog title="Seguimiento" :visible.sync="dialogMensaje" width="50%" :before-close="handleClose">
      <br />
      <div v-if="
        solicitud.seguimiento &&
        solicitud.seguimiento[0]['estado'] !== 'Solicitud finalizada'
      ">
        Seleccione un estado: <br />
        <el-select style="margin-top: 10px" v-model="estado" size="small" placeholder="Seleccione una opción">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <br /><br />
        Escriba un comentario: <br />
        <el-input style="margin-top: 10px" v-model="comentario" size="small" :rows="2" type="textarea"></el-input>
        <br /><br />
        <el-button size="small" type="primary" icon="el-icon-plus" @click="addSeguimiento">Ingresar
          seguimiento</el-button>
        <br /><br />
      </div>

      <el-table row-class-name="rowClassTablaPloma" cell-class-name="cellClassTablaPloma"
        header-cell-class-name="header-cell-class-table-gray" :data="solicitud.seguimiento" style="width: 100%">
        <el-table-column prop="fecha" label="Fecha" width="300">
        </el-table-column>
        <el-table-column prop="estado" label="Estado" width="170">
          <template slot-scope="scope">
            <el-tag size="medium" :type="scope.row.estado === 'Solicitud ingresada'
              ? 'info'
              : scope.row.estado === 'Solicitud en trámite'
                ? 'warning'
                : scope.row.estado === 'Solicitud finalizada'
                  ? 'success'
                  : ''
              ">{{ scope.row.estado }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="comentarios" label="Comentarios">
          <template slot-scope="scope">
            <el-tag type="danger" size="medium" v-if="scope.row.comentarios === ''">Sin comentarios</el-tag>
            <span v-else>{{ scope.row.comentarios }}</span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClose">Cancelar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import copy from "copy-to-clipboard";
import moment from "moment";
import axios from "axios";

export default {
  name: "soporte",
  components: {},
  data() {
    return {
      gerencias: [],
      gerencias_generales: [],
      superintendencias: [],
      faena_selected: "",
      dialogMensaje: false,
      dialogVer: false,
      solicitud: {},
      solicitudes: [],
      totalPage: 0,
      page: 1,
      search: "",
      options: [
        {
          value: "Solicitud en trámite",
          label: "Solicitud en trámite",
        },
        {
          value: "Solicitud finalizada",
          label: "Solicitud finalizada",
        },
      ],
      estado: "",
      comentario: "",
    };
  },
  computed: {},
  async created() {
    this.$store.dispatch("setSubTitle", "Administración de soporte");
    this.$store.dispatch("getFaenas");
    this.faena_selected = this.$store.getters.role.faena_id;
    this.getSolicitudes();
  },
  watch: {
    "$store.getters.notification_selected": {
      handler: async function (val, oldVal) {
        this.faena_selected = val.faena_id;
        this.getSolicitudes();
        await this.getSolicitud(val.codigo);
        this.solicitud.seguimiento = this.solicitud.seguimiento.reverse();
        this.dialogMensaje = true;
      },
      deep: true,
    }
  },
  methods: {
    async getSolicitud(codigo) {
      let response = await axios.get(
        `/contratos/getSolicitudId/${codigo}`
      );
      this.solicitud = response.data.length > 0 ? response.data[0] : {};
    },
    async getGerenciasGenerales() {
      let response = await axios.get(
        `/data-science/getGerenciasGenerales/${this.faena_selected}`
      );
      this.gerencias_generales = response.data;
    },
    async getGerencias(id) {
      let response = await axios.get(
        `/data-science/getGerencias/${this.faena_selected}/${id}`
      );
      this.gerencias = response.data;
    },
    async getSuperintendencias(id_gerencia) {
      let response = await axios.get(
        `/data-science/getSuperintendencias/${id_gerencia}`
      );
      this.superintendencias = response.data;
    },
    getFaena(faena_id) {
      const faena = this.$store.getters.faenas.find((x) => x._id === faena_id);
      if (faena && faena.nombre) {
        return faena.nombre;
      }
    },
    async addSeguimiento() {
      if (this.estado === "" || this.comentario === "") {
        this.$alert(
          "Para continuar debes completar todos los datos solicitados.",
          "Atención",
          {
            type: "warning",
            confirmButtonText: "Aceptar",
            callback: (action) => { },
          }
        );
        return false;
      }
      const response = await axios.post(
        `/contratos/add-seguimiento`,
        {
          id: this.solicitud._id,
          estado: this.estado,
          comentario: this.comentario,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (response.data.success === true) {
        this.$alert(response.data.message, "Información importante", {
          type: "success",
          confirmButtonText: "Aceptar",
          callback: (action) => { },
        });
        this.getSolicitudes();
        this.$store.dispatch("getNotifications");
        this.handleClose();
      } else {
        this.$alert(response.data.message, "Información importante", {
          type: "error",
          confirmButtonText: "Aceptar",
          callback: (action) => { },
        });
      }
    },
    openMensaje(row) {
      this.solicitud = JSON.parse(JSON.stringify(row));
      this.solicitud.seguimiento = this.solicitud.seguimiento.reverse();
      this.dialogMensaje = true;
    },
    copiar(texto) {
      copy(texto);
      this.$message("Texto copiado.");
    },
    handleClose() {
      this.comentario = "";
      this.estado = "";
      this.solicitud = {};
      this.dialogVer = false;
      this.dialogMensaje = false;
    },
    openVer(row) {
      this.solicitud = JSON.parse(JSON.stringify(row));
      this.getGerencias(this.solicitud.gerencia_general);
      this.getGerenciasGenerales();
      this.getSuperintendencias(this.solicitud.gerencia);
      this.dialogVer = true;
    },
    dateFromObjectId(objectId) {
      return new Date(parseInt(objectId.substring(0, 8), 16) * 1000);
    },
    currentPage(page) {
      this.page = page;
      this.getSolicitudes();
    },
    nextPage(page) {
      this.page = page;
      this.getSolicitudes();
    },
    backPage(page) {
      this.page = page;
      this.getSolicitudes();
    },
    getSolicitudes() {
      this.loading = true;
      const self = this;
      axios
        .get(
          `/contratos/getSolicitudes/${this.page}/${this.search === "" ? undefined : this.search
          }/${this.faena_selected === "" ? undefined : this.faena_selected}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        )
        .then((response) => {
          self.solicitudes = response.data.results;
          self.totalPage = response.data.total;
          self.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.content {
  min-height: 50vh;
}

.search {
  max-width: 450px;
}
</style>
